export var Networks;
(function (Networks) {
    Networks[Networks["mainnet"] = 1] = "mainnet";
    Networks[Networks["ropsten"] = 3] = "ropsten";
    Networks[Networks["rinkeby"] = 4] = "rinkeby";
    Networks[Networks["kovan"] = 42] = "kovan";
    Networks[Networks["xdai"] = 100] = "xdai";
    Networks[Networks["novichok"] = 1984] = "novichok";
    Networks[Networks["bracknell"] = 1999] = "bracknell";
    Networks[Networks["unknown"] = -1] = "unknown";
})(Networks || (Networks = {}));
//# sourceMappingURL=networks.js.map